import { NgStyle } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation, signal } from '@angular/core';

import { parityColor } from '@shared/models/styles.model';
import { DesignData } from '@shared/models/survey.model';
import { SafeHtml } from '@shared/pipes/safe-html.pipe';

@Component({
  selector: 'partner-banner',
  templateUrl: './partner-banner.component.html',
  styleUrls: ['./partner-banner.component.scss'],
  imports: [NgStyle, SafeHtml],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class PartnerBanner {
  private _designData: DesignData | null = null;

  readonly isReady = signal(false);

  @Input() html: string | null = null;

  @Input() set designData(value: DesignData | null) {
    this._designData = value ? new DesignData(value) : null;
    this.isReady.set(value != null);
  }

  get designData(): DesignData | null {
    return this._designData;
  }

  get backgroundColor(): string {
    return this.designData?.colors?.primary || '';
  }

  get textColor(): string {
    return parityColor(this.backgroundColor) || '';
  }

  get textStyles(): Record<string, string> {
    return this.designData?.font?.getStyles(this.textColor) || {};
  }
}
